import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/login'
import infoManage from '@/infoManage/index'
import InfoList from '@/infoManage/infoList'
import teacherInfo from '@/infoManage/teacherInfo'
import Tongji from '@/infoManage/tongji'
import MenuManage from '@/menuManage/index'
import UserManage from '@/userManage/index'
import EnrollDetail from '@/enrollDetail/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/infoManage',
      name: 'infoManage',
      component: infoManage
    },
    {
      path: '/infoList',
      name: 'InfoList',
      component: InfoList
    },
    {
      path: '/teacherInfo',
      name: 'TeacherInfo',
      component: teacherInfo
    },
    {
      path: '/tongji',
      name: 'Tongji',
      component: Tongji
    },
    {
      path: '/menuManage',
      name: 'MenuManage',
      component: MenuManage
    },
    {
      path: '/userManage',
      name: 'UserManage',
      component: UserManage
    },
    {
      path: '/enrollDetail',
      name: 'EnrollDetail',
      component: EnrollDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js